
export default function LegislativeWinsSection() {
  const legislativeWins = [
    {
      title: "Pharmacist Immunization Authority",
      date: "March 2024",
      description: "Successfully secured authorization for pharmacists to administer all routine immunizations across 8 provinces, improving public health accessibility.",
      impact: "2.3M+ additional vaccination opportunities annually",
      provinces: ["BC", "AB", "SK", "MB", "ON", "QC", "NB", "NS"],
      icon: "ri-syringe-line"
    },
    {
      title: "Veterinary Emergency Care Protocol",
      date: "January 2024",
      description: "Established new emergency care protocols allowing veterinarians extended authority during after-hours and emergency situations.",
      impact: "24/7 emergency care coverage expanded by 40%",
      provinces: ["National"],
      icon: "ri-heart-pulse-line"
    },
    {
      title: "Collaborative Care Framework",
      date: "November 2023",
      description: "Implemented framework enabling formal collaboration between pharmacists and veterinarians in zoonotic disease management.",
      impact: "Improved disease prevention and control",
      provinces: ["BC", "AB", "ON", "QC"],
      icon: "ri-team-line"
    },
    {
      title: "Prescription Adaptation Rights",
      date: "September 2023",
      description: "Expanded pharmacist authority to adapt prescriptions for therapeutic equivalence and emergency situations.",
      impact: "Reduced medication delays by 35%",
      provinces: ["All Provinces"],
      icon: "ri-file-edit-line"
    },
    {
      title: "Telehealth Regulatory Approval",
      date: "June 2023",
      description: "Secured comprehensive regulatory approval for veterinary telehealth consultations and remote monitoring.",
      impact: "Rural healthcare access improved by 60%",
      provinces: ["BC", "AB", "SK", "MB", "ON"],
      icon: "ri-video-chat-line"
    },
    {
      title: "Minor Ailment Prescribing",
      date: "April 2023",
      description: "Expanded pharmacist prescribing authority for minor ailments and common conditions.",
      impact: "Reduced healthcare wait times by 25%",
      provinces: ["BC", "AB", "ON", "NB", "NS"],
      icon: "ri-medicine-bottle-line"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-trophy-line text-2xl text-green-600"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Recent Legislative Wins
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Celebrating our successful advocacy efforts that have transformed healthcare policy across Canada
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {legislativeWins.map((win, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                  <i className={`${win.icon} text-xl text-green-600`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900">
                    {win.title}
                  </h3>
                  <span className="text-sm text-gray-500">{win.date}</span>
                </div>
              </div>

              <p className="text-gray-600 mb-4">
                {win.description}
              </p>

              <div className="bg-green-50 rounded-lg p-3 mb-4">
                <div className="flex items-center mb-2">
                  <i className="ri-bar-chart-line text-green-600 mr-2"></i>
                  <span className="text-sm font-medium text-green-800">Impact</span>
                </div>
                <p className="text-green-700 text-sm">
                  {win.impact}
                </p>
              </div>

              <div>
                <span className="text-sm text-gray-500 mb-2 block">Affected Regions:</span>
                <div className="flex flex-wrap gap-1">
                  {win.provinces.map((province, idx) => (
                    <span key={idx} className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded font-medium">
                      {province}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-green-900 rounded-lg p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">Our Advocacy Success</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <div className="text-3xl font-bold mb-2">18</div>
              <div>Major Legislative Wins</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">95%</div>
              <div>Campaign Success Rate</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">8.5M</div>
              <div>Canadians Impacted</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
